module.exports = __webpack_public_path__ + "img/13.24829b0d.png";